import { AdminUserOperationsWorkspace } from "@/features/admin/pages/AdminUsersPage";

export function AdminBansPage() {
  return <AdminUserOperationsWorkspace mode="bans" />;
}
